import React, { useEffect, useMemo, useState } from 'react';
import { TablePagination } from '../../../common/details-table/table-pagination.component';

// remove this once API implemented
const MOCK_HISTORY_ITEMS = [
    { ModifiedDate: '2026-08-01 09:12', ModifiedBy: 'jdela.cruz', Field: 'Enable Kyber Agents', OldValue: 'false', NewValue: 'true', Action: 'Updated' },
    { ModifiedDate: '2026-07-28 14:45', ModifiedBy: 'mcanson', Field: 'Roles Enabled', OldValue: 'Vendor Admin', NewValue: 'Vendor Admin, Approver', Action: 'Updated' },
    { ModifiedDate: '2026-07-20 08:03', ModifiedBy: 'system', Field: 'Kyber Config', OldValue: '', NewValue: 'Created', Action: 'Added' },
];

const DEFAULT_HEADERS = {
    ModifiedDate: { name: 'Date Modified', propName: 'ModifiedDate', hidden: false, order: 1, searchString: '' },
    ModifiedBy: { name: 'Modified By', propName: 'ModifiedBy', hidden: false, order: 2, searchString: '' },
    Field: { name: 'Field', propName: 'Field', hidden: false, order: 3, searchString: '' },
    OldValue: { name: 'Old Value', propName: 'OldValue', hidden: false, order: 4, searchString: '' },
    NewValue: { name: 'New Value', propName: 'NewValue', hidden: false, order: 5, searchString: '' },
    Action: { name: 'Action', propName: 'Action', hidden: false, order: 6, searchString: '' },
};

const PAGE_SIZES = [10, 20, 30];

const KyberConfigDetailsHistory = ({ isColSearchShow }) => {
    const [headers, setHeaders] = useState(DEFAULT_HEADERS);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);

    const filteredItems = useMemo(() => {
        return MOCK_HISTORY_ITEMS.filter(item =>
            Object.values(headers).every(header =>
                !header.searchString ||
                String(item[header.propName] ?? '').toLowerCase().includes(header.searchString.toLowerCase())
            )
        );
    }, [headers]);

    useEffect(() => {
        setPageIndex(0);
    }, [pageSize]);

    const pagedItems = useMemo(() => {
        const start = pageIndex * pageSize;
        return filteredItems.slice(start, start + pageSize);
    }, [filteredItems, pageIndex, pageSize]);

    const totalPages = Math.max(Math.ceil(filteredItems.length / pageSize), 1);

    const onColumnSearchChange = (event, key) => {
        const { value } = event.target;
        setHeaders(prev => ({
            ...prev,
            [key]: { ...prev[key], searchString: value }
        }));
    };

    const onColumnSearch = () => {
        setPageIndex(0);
    };

    const resizePage = (size) => {
        setPageSize(parseInt(size, 10));
    };

    return (
        <TablePagination
            key="kyberconfig-history-table-pagination"
            columns={headers}
            pageList={pagedItems}
            pages={{
                PageNumber: pageIndex,
                TotalPages: totalPages,
                PerPage: pageSize,
                PageSizes: PAGE_SIZES,
                TotalEntries: filteredItems.length,
                HasNext: pageIndex < totalPages - 1,
                HasPrevious: pageIndex > 0,
            }}
            paginationAction={setPageIndex}
            onColumnSearch={onColumnSearch}
            onColumnSearchChange={onColumnSearchChange}
            isColSearchShow={isColSearchShow}
            resizePage={resizePage}
            totalPage={filteredItems.length}
            isNotSortable={true}
            isLoading={false}
            hideStatusIcon={true}
        />
    );
};

export default KyberConfigDetailsHistory;
